import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import GuardImage from 'shared/images/guard.webp'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

interface InsuranceProgramDetailsDialogProps {
  title: string
  description: string
  onClose: () => void
}

export const InsuranceProgramDetailsDialog: FC<
  InsuranceProgramDetailsDialogProps
> = ({ title, description, onClose }) => {
  const { t } = useTranslation()

  return (
    <div className={s.dialog}>
      <ImageOptimized
        src={GuardImage}
        width={54}
        height={64}
        objectFit="contain"
      />

      <div>
        <h2 className={clsx(s.title, 'bold-20')}>
          {t('insurance.vzr.program.details_title', { coverage: title })}
        </h2>
        <p className={clsx(s.description, 'medium-14')}>{description}</p>
      </div>
      <Button
        type="button"
        className={clsx(s.button, 'bold-17')}
        onClick={onClose}
      >
        {t('insurance.vzr.program.close')}
      </Button>
    </div>
  )
}
